import React from "react";
import {
  Typography,
  Button,
  Modal,
  FormControl,
  Select,
  MenuItem,
  Box,
  Paper,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FONT_FAMILY } from "common/sharedFunctions";

const AddToWallet = ({
  getStyles,
  role,
  settings,
  setSelectedProviderIndex,
  setAmount,
  setCommonAlert,
  profile,
  icons,
  handleSubmit,
  providers,
  setSelectedProvider,
  classes,
  createOrderId,
  rootRef,
  amount,
  modalOpen,
  modalType,
  handleCloseModal,
  selectedProvider,
  selectedProviderIndex,
}) => {
  const { t } = useTranslation();
  const auth = useSelector((state) => state.auth);
  const inputStyle = { fontFamily: FONT_FAMILY };

  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open={modalOpen}
      onClose={handleCloseModal}
      className={classes.modal}
      container={() => rootRef.current}
    >
      <Paper className={classes.paper}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleCloseModal}
        >
          <CloseIcon />
        </IconButton>

        <Box className={classes.modalContent}>
          <Typography variant="h4" className={classes.modalHeader}>
            {role === "customer"
              ? t("amount")
              : modalType === "add"
              ? t("amount_to_add")
              : t("amount_to_withdraw")}
          </Typography>

          <Typography variant="subtitle1" className={classes.modalSubheader}>
            {t("amount")}
          </Typography>

          <input
            type="text"
            placeholder={t("amount_to_withdraw_from")}
            value={amount === 0 ? "" : amount}
            onChange={(e) => {
              try {
                if (e.target.value === "") {
                  setAmount(0);
                } else {
                  setAmount(parseFloat(e.target.value));
                }
              } catch (e) {
                setCommonAlert({ open: true, msg: t("no_details_error") });
                setAmount(0);
              }
            }}
            className={classes.amountInput}
            style={{ marginBottom: "24px" }}
          />

          {modalType === "add" && (
            <>
              <Typography variant="subtitle1" className={classes.formLabel}>
                {t("payment")}
              </Typography>

              <FormControl
                fullWidth
                variant="outlined"
                style={{ marginBottom: "24px" }}
              >
                <Select
                  className={classes.selectField}
                  value={selectedProviderIndex}
                  onChange={(e) => {
                    setSelectedProviderIndex(parseInt(e.target.value));
                    setSelectedProvider(providers[parseInt(e.target.value)]);
                  }}
                  displayEmpty
                  renderValue={(selected) => {
                    if (selected === "") {
                      return <em>Select payment method</em>;
                    }
                    return (
                      <Box display="flex" alignItems="center">
                        <img
                          style={{ height: 24, marginRight: 8 }}
                          src={icons[providers[selected].name]}
                          alt={providers[selected].name}
                        />
                        {/* {providers[selected].name} */}
                      </Box>
                    );
                  }}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  {/* <MenuItem value="" disabled>
                      <em>Select payment method</em>
                    </MenuItem> */}
                  {providers?.map((provider, index) => (
                    <MenuItem key={provider.name} value={index}>
                      <Box display="flex" alignItems="center">
                        <img
                          style={{ height: 24, marginRight: 8 }}
                          src={icons[provider.name]}
                          alt={provider.name}
                        />
                        {/* {provider.name} */}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </>
          )}

          <Box className={classes.buttonContainer}>
            <Button
              onClick={handleCloseModal}
              variant="outlined"
              className={`${classes.modalButton} ${classes.cancelButton}`}
              fullWidth
              style={{ marginRight: "12px" }}
            >
              {t("cancel")}
            </Button>

            {modalType === "add" ? (
              <form
                action={selectedProvider?.link}
                method="POST"
                style={{ width: "100%" }}
              >
                <input
                  type="hidden"
                  name="order_id"
                  style={inputStyle}
                  value={createOrderId()}
                />
                <input
                  type="hidden"
                  name="amount"
                  style={inputStyle}
                  value={amount}
                />
                <input
                  type="hidden"
                  name="currency"
                  style={inputStyle}
                  value={settings.code}
                />
                <input
                  type="hidden"
                  name="product_name"
                  style={inputStyle}
                  value={t("add_money")}
                />
                <input
                  type="hidden"
                  name="first_name"
                  style={inputStyle}
                  value={profile?.firstName}
                />
                <input
                  type="hidden"
                  name="last_name"
                  style={inputStyle}
                  value={profile?.lastName}
                />
                <input
                  type="hidden"
                  name="quantity"
                  style={inputStyle}
                  value={1}
                />
                <input
                  type="hidden"
                  name="cust_id"
                  style={inputStyle}
                  value={auth.profile?.uid}
                />
                <input
                  type="hidden"
                  name="mobile_no"
                  style={inputStyle}
                  value={profile?.mobile}
                />
                <input
                  type="hidden"
                  name="email"
                  style={inputStyle}
                  value={profile?.email}
                />

                <Button
                  type="submit"
                  variant="contained"
                  className={`${classes.modalButton}`}
                  sx={{ ...getStyles(role).actionButton }}
                  fullWidth
                  endIcon={<ArrowForwardIcon />}
                  disabled={amount <= 0 || !selectedProvider}
                >
                  {t("fund_wallet")}
                </Button>
              </form>
            ) : (
              <Button
                onClick={handleSubmit}
                variant="contained"
                className={`${classes.modalButton}`}
                sx={{ ...getStyles(role).actionButton }}
                fullWidth
                endIcon={<ArrowForwardIcon />}
              >
                Withdraw
              </Button>
            )}
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
};

export default AddToWallet;
